import React from 'react';
import classnames from 'classnames';
import {
  Table,
} from 'reactstrap';

import { Intl } from 'components';

export default React.memo( ( {
  getTableProps, headerGroups, page, prepareRow, tableClassName, getRowProps = () => ( {} ), values = {}
} ) => (
  <div className={classnames( 'table-responsive', { 'no-scroll': !page.length } )}>
    <Table className={classnames( 'align-items-center table-flush', tableClassName )} {...getTableProps()}>
      <thead className="thead-light">
        {headerGroups.map( ( headerGroup ) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map( ( column ) => (
              <th
                className="cursor-pointer"
                {...( !column.disableSorting
                  ? column.getHeaderProps( {
                    ...column.getSortByToggleProps(),
                    ...{
                      style: column.customWidth ? {
                        flex: `${column.customWidth} 0 auto`,
                        width: column.customWidth,
                        maxWidth: column.customWidth,
                        minWidth: column.customWidth,
                        ...column.style,
                      } : { ...column.style },
                    },
                  } )
                  : column.getHeaderProps( {
                    style: column.customWidth ? {
                      flex: `${column.customWidth} 0 auto`,
                      width: column.customWidth,
                      maxWidth: column.customWidth,
                      minWidth: column.customWidth,
                    } : { ...column.style },
                  } ) )
              }
              >
                {column.render( 'Header' ) && column.disableTranslate !== true
                  ? <Intl id={column.render( 'Header' )} values={values} /> : column.render( 'Header' )}
                {/* {!column.disableSorting
              && (
                <span
                  className={classnames( 'fas ml-1', {
                    'fa-sort': !column.isSorted,
                    'fa-sort-up': column.isSorted && !column.isSortedDesc,
                    'fa-sort-down': column.isSorted && column.isSortedDesc,
                  } )}
                />
              )} */}
              </th>
            ) )}
          </tr>
        ) )}
      </thead>
      <tbody className="list">
        {
        page.length ? page.map(
          ( row ) => prepareRow( row ) || (
            <tr {...row.getRowProps( getRowProps( row ) )}>
              {row.cells.map( ( cell ) => (
                <td
                  {...cell.getCellProps(
                    cell.column.customWidth ? {
                      style: {
                        verticalAlign: 'middle',
                        flex: `${cell.column.customWidth} 0 auto`,
                        width: cell.column.customWidth,
                        maxWidth: cell.column.customWidth,
                        minWidth: cell.column.customWidth,
                        ...cell.column.style,
                      },
                    } : { style: cell.column.style },
                  )}
                >
                  {cell.render( 'Cell' )}
                </td>
              ) )}
            </tr>
          ),
        ) : (
          <tr>
            <td colSpan={100} className="text-center">
              <Intl id="noTableData" />
            </td>
          </tr>
        )
      }
      </tbody>
    </Table>
  </div>
) );
